const logActionTypes =  {    
    RETRIEVED_LOG_LIST: "RETRIEVED_LOG_LIST",
    RETRIEVED_PORTAL_LIST: "RETRIEVED_PORTAL_LIST",
    RETRIEVED_LOGTYPE_LIST: "RETRIEVED_LOGTYPE_LIST",
    DELETED_LOG_ITEMS: "DELETED_LOG_ITEMS",
    EMAILED_LOG_ITEMS: "EMAILED_LOG_ITEMS",
    SELECTED_ROW: "SELECTED_ROW",
    DESELECTED_ROW: "DESELECTED_ROW",
    SELECTED_ALL: "SELECTED_ALL",
    DESELECTED_ALL: "DESELECTED_ALL",
    CLEARED_LOG: "CLEARED_LOG"
};
export default logActionTypes;
